module.exports = __webpack_public_path__ + "img/Infrastructure.582cdfc0.jpg";